import React, { useEffect, useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "../ui/carousel";
import { Sparkles } from "lucide-react";
import { Price } from "./Shop";
import { assets } from "../../mock";

const isNew = (b) => /nuov|novit|new/i.test(b || "");

export const FeaturedCarousel = ({ products, onOpen, onAdd }) => {
  const [api, setApi] = useState(null);
  const items = products.filter((p) => p.old_price || p.on_sale || isNew(p.badge));

  useEffect(() => {
    if (!api) return;
    const id = setInterval(() => api.scrollNext(), 4000);
    return () => clearInterval(id);
  }, [api]);

  if (!items.length) return null;
  return (
    <div data-testid="featured-carousel">
      <div className="flex items-center gap-2 mb-5">
        <Sparkles className="w-5 h-5 text-[#CF1072]" />
        <h3 className="text-white font-bold text-[20px]">Offerte e novità del momento</h3>
      </div>
      <Carousel setApi={setApi} opts={{ loop: true, align: "start" }} className="px-1">
        <CarouselContent>
          {items.map((p) => (
            <CarouselItem key={p.product_id} className="basis-1/3 sm:basis-1/4 lg:basis-1/6">
              <div onClick={() => onOpen(p)} className="group cursor-pointer bg-white/10 backdrop-blur-md border border-white/15 rounded-xl p-2 h-full hover:bg-white/15 transition-colors duration-300" data-testid={`featured-${p.product_id}`}>
                <div className="relative rounded-xl overflow-hidden bg-white aspect-[4/3]">
                  <img src={p.img || assets.logo} alt={p.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <span className={`absolute top-2 left-2 text-white text-[9px] font-bold uppercase px-1.5 py-0.5 rounded-full ${p.old_price || p.on_sale ? "bg-[#CF1072]" : "bg-[#1A237E]"}`}>
                    {p.old_price ? `-${Math.round((1 - p.price / p.old_price) * 100)}%` : p.on_sale ? "Offerta" : p.badge}
                  </span>
                </div>
                <h4 className="text-white font-bold text-[12px] leading-tight mt-2 line-clamp-2 min-h-[30px]">{p.name}</h4>
                <Price p={p} />
                {p.price != null && (
                  <button onClick={(e) => { e.stopPropagation(); onAdd(p); }} className="mt-2 w-full h-[26px] text-[11px] rounded-full bg-[#CF1072] text-white hover:bg-[#8f11a8] transition-colors duration-200" data-testid={`featured-add-${p.product_id}`}>
                    Aggiungi al carrello
                  </button>
                )}
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="hidden md:flex -left-5 bg-white/90" data-testid="featured-prev" />
        <CarouselNext className="hidden md:flex -right-5 bg-white/90" data-testid="featured-next" />
      </Carousel>
    </div>
  );
};
